import moment from 'moment'

export const getters = {
  authUserEntityActivities (state) {
    return state.authUserEntityActivities
  },

  userIsAudiologist (state) {
    if (state.hasLoadedAuthUserEntityActivities) {
      return state.authUserEntityActivities.some(record => record.activity.id === state.activities.AUDIOLOGY)
    }
    return false
  },

  userIsDispenser (state) {
    if (state.hasLoadedAuthUserEntityActivities) {
      return state.authUserEntityActivities.some(record => record.activity.id === state.activities.DISPENSER_FIELD || record.activity.id === state.activities.DISPENSER_PREMISES)
    }
    return false
  },

  userIsActiveAudiologist (state) {
    if (state.hasLoadedAuthUserEntityActivities) {
      return state.authUserEntityActivities.some(record => {
        let isAfterStartDate = record.start_date === null ? true : moment(record.start_date).isBefore(moment())
        let isBeforeEndDate = record.end_date === null ? true : moment(record.end_date).isAfter(moment())
        return record.activity.id === state.activities.AUDIOLOGY && isAfterStartDate && isBeforeEndDate
      })
    }
    return false
  },

  userPerformsActivities (state) {
    if (state.hasLoadedAuthUserEntityActivities) {
      return state.authUserEntityActivities.length > 0
    }
    return false
  }
}
